import { myLocalStorage } from './myLocalStorage';

const key = 'CACHE_REPORT_DATA';

export default {
  /**
 * 添加临时rum缓存。用于页面将要reload时想上报数据，但因为页面刷新被打断的情况。
 * 会先将数据缓存起来，然后等页面再次加载后重新上传。
 * @param data 要上报的rum数据
 * @param expire 有效时间，默认3秒。过期后将被丢弃
 */
  add(data: any, expire: number = 3 * 1000) {
    console.log('[setCacheReportData]', data, expire);
    const NOW = Date.now();
    try {
      const cacheList = JSON.parse(myLocalStorage.getItem(key) || '[]');
      cacheList.push({
        data,
        time: NOW,
        expire: NOW + expire,
      });
      myLocalStorage.setItem(key, JSON.stringify(cacheList));
    } catch (ex) {
      console.error('[setCacheReportData]', ex);
    }
  },
  /**
 * @returns 获取临时缓存
 */
  get(clearCache: boolean): Array<any> {
    const NOW = Date.now();
    const rs: Array<any> = [];

    try {
      const cacheList = JSON.parse(myLocalStorage.getItem(key) || '[]');

      cacheList.forEach((item) => {
        if (item && item.expire && item.expire >= NOW) {
          rs.push(item.data);
        }
      });
    } catch (ex) {
      console.error('[getCacheReportData]', ex);
    }

    // 清空缓存
    clearCache && myLocalStorage.removeItem(key);
    return rs;
  },
  /**
 * 上报rum日志
 * @param report 上报方法
 */
  report(report: Function) {
    const cacheData = this.get(true);
    cacheData.forEach((item) => {
      report(item);
    });
  },
};
